import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-20",
  "use": "icon-button_icon-20-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-20\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M23 8v12a2 2 0 01-2 2H3a2 2 0 01-2-2V8\" /><path stroke-linejoin=\"round\" d=\"M6 2h12l5 6H1z\" /><path d=\"M6 12h9.134C16.717 12 18 13.343 18 15s-1.283 3-2.866 3H9.4M6 12l2 2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol